import Axios from 'axios'
import strings from '@/strings'

export default {
  getProfiles (clientId) {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${clientId}/profiles`)
  },
  addProfile (clientId) {
    return Axios.post(`api/${strings.apiVersion.public}/clients/${clientId}/profiles`)
  },
  removeProfile (clientId, userName) {
    return Axios.delete(`api/${strings.apiVersion.public}/clients/${clientId}/profiles/${encodeURIComponent(userName)}`)
  }
}
